var map = {
	"./E@2x.png": 167,
	"./ENE@2x.png": 168,
	"./ESE@2x.png": 169,
	"./N@2x.png": 170,
	"./NE@2x.png": 171,
	"./NNE@2x.png": 172,
	"./NNW@2x.png": 173,
	"./NW@2x.png": 174,
	"./S@2x.png": 175,
	"./SE@2x.png": 176,
	"./SSE@2x.png": 177,
	"./SSW@2x.png": 178,
	"./SW@2x.png": 179,
	"./W@2x.png": 180,
	"./WNW@2x.png": 181,
	"./WSW@2x.png": 182
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 166;